import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/inscription.svg'


const _withScopeId = n => (_pushScopeId("data-v-1859c94a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-100"
}, null, -1))
const _hoisted_3 = { class: "d-flex align-items-center flex-column justify-content-center h-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fs-3" }, " Rejoignez notre Plateforme avec Votre Compte Personnel ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "sr-only",
  for: "username"
}, "Numero de telephone", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "sr-only",
  for: "password"
}, "Mot de passe", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "sr-only",
  for: "repeatpassword"
}, "Confirmation de mot de passe", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Avez vous un parrain ?", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Enttrez le son code et obtenez jusqu'a "),
  /*#__PURE__*/_createElementVNode("strong", null, " 5000 FCFA"),
  /*#__PURE__*/_createTextVNode(" de réduction")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "sr-only",
  for: "parrain"
}, "Code de parrainage", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_input_group = _resolveComponent("b-input-group")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _hoisted_2
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, { cols: "1" }),
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _hoisted_4,
                    _createElementVNode("p", null, [
                      _createTextVNode(" Deja membre ?? "),
                      _createVNode(_component_b_button, {
                        variant: "link",
                        to: "/",
                        class: "p-0"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Connectez-vous ")
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_b_form, {
                        onSubmit: _ctx.onSubmit,
                        prevent: "submit",
                        class: "d-flex flex-column ju"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createVNode(_component_b_form_input, {
                            type: "tel",
                            id: "username",
                            modelValue: _ctx.user.username,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.username) = $event)),
                            class: _normalizeClass(["mb-2 mr-sm-2 mb-sm-3", {}]),
                            placeholder: "Entrez votre numero de telephone"
                          }, null, 8, ["modelValue"]),
                          _hoisted_6,
                          _createVNode(_component_b_form_input, {
                            type: "password",
                            id: "password",
                            modelValue: _ctx.user.password,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password) = $event)),
                            class: "mb-2 mr-sm-2 mb-sm-3",
                            placeholder: "Entrez votre mot de passe"
                          }, null, 8, ["modelValue"]),
                          _hoisted_7,
                          _createVNode(_component_b_form_input, {
                            type: "password",
                            id: "repeatpassword",
                            modelValue: _ctx.user.repeatPassword,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.repeatPassword) = $event)),
                            class: "mb-2 mr-sm-2 mb-sm-3",
                            placeholder: "Veuillez confirmer votre mot de passe"
                          }, null, 8, ["modelValue"]),
                          _hoisted_8,
                          _hoisted_9,
                          _hoisted_10,
                          _createVNode(_component_b_input_group, { class: "mb-2 mr-sm-2 mb-sm-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_form_input, {
                                id: "parrain",
                                modelValue: _ctx.user.parrain,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.parrain) = $event)),
                                placeholder: "Entrez votre code de parrainage"
                              }, null, 8, ["modelValue"])
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_b_button, {
                            type: "submit",
                            style: {"align-self":"end"},
                            variant: "primary",
                            class: "w-50"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("inscription")
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }, 8, ["onSubmit"])
                    ])
                  ])
                ])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    })
  ]))
}